import React from 'react';
import { Grid, Box } from '@mui/material';
import { useState, useEffect } from 'react';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import AddTeam from '../../Forms/AddTeam/AddTeam';
import { useGetAllTeams, useGetAllTeamsByParentId } from '../../Hooks';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@mui/material';
import TeamCart from '../TeamCart/TeamCart';
import EditTeam from '../../Forms/EditTeam/EditTeam';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import AccessLevel from '../../Forms/AccessLevel/AccessLevel';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const Teams = (props: any) => {
    let { id }: any = props;
    const tenantId = useSelector((state: any) => state.meetings.profileTenantId);
    const [teamId, setTeamId] = useState<string | null>(null);
    const [showAddTeam, setShowAddTeam] = useState<Boolean | null>(false);
    const [showEditTeam, setShowEditTeam] = useState<Boolean | null>(false);
    const [showAccessLevel, setShowAccessLevel] = useState<Boolean | null>(false);
    const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
    const [teamAsynOpcState, setTeamAsyncOpState] = useState<any>(null);
    const [teamD, setTeamD] = useState<any[]>();
    const { data: teamsDataCild, isLoading: getTeamLoadingCild } = useGetAllTeamsByParentId(id);
    const { data: teamsData, isLoading: getTeamLoading, isSuccess, isFetched } = useGetAllTeams(tenantId);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه

    const initialAddTeam = () => {
        setShowAddTeam(prev => !prev);
    };

    const initialEditTeam = () => {
        setShowAccessLevel(false);
        setShowEditTeam(true);
    };

    const initialAccessLevelTeam = () => {
        setShowAccessLevel(true);
        setShowEditTeam(false);
    };

    useEffect(() => {
        if (id !== '' && id !== undefined && id !== null) {
            setTeamD(teamsDataCild);
        } else {
            setTeamD(teamsData);
        }
    }, [id !== '' && id !== undefined && id !== null ? teamsDataCild : teamsData]);

    if (getTeamLoading) {
        return (
            <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                width={'99%'}
                py={20}
                mx={'auto'}
                boxShadow={4}
                borderRadius={3}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <>
            <Grid container>
                <Grid item xs={12} md={12} mx={2}>
                    <Box display={'flex'} flexDirection={'row-reverse'} py={1} px={2}>
                        <Box>
                            <DyButton
                                caption={'افزودن تیم'}
                                onClick={initialAddTeam}
                                color={'red'}
                                disbled={false}
                                variant={'contained'}
                                type={'button'}
                                bgColor={'#00387C'}
                            />
                        </Box>

                        {showAddTeam && (
                            <ModalLyt
                                showModal={showAddTeam}
                                setShowModal={setShowAddTeam}
                                height={500}
                                width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
                                title={'ایجاد تیم'}
                                overflow="inherit"
                            >
                                <AddTeam
                                    setShowToastMessage={setShowToastMessage}
                                    setAddTeamState={setTeamAsyncOpState}
                                    onClose={setShowAddTeam}
                                    id={id}
                                />
                            </ModalLyt>
                        )}

                        {showEditTeam && (
                            <ModalLyt
                                showModal={showEditTeam}
                                setShowModal={setShowEditTeam}
                                height={500}
                                width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
                                title={'ویرایش تیم'}
                                overflow="inherit"
                            >
                                <EditTeam
                                    teamId={teamId}
                                    onClick={initialEditTeam}
                                    loading={getTeamLoading}
                                    onClose={setShowEditTeam}
                                    setShowToastMessage={setShowToastMessage}
                                    setEditTeamState={setTeamAsyncOpState}
                                />
                            </ModalLyt>
                        )}

                        {showAccessLevel && (
                            <ModalLyt
                                showModal={showAccessLevel}
                                setShowModal={setShowAccessLevel}
                                height={700}
                                width={isMobile ? '350px' : '800px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
                                title={'تعیین سطوح دسترسی'}
                            >
                                <AccessLevel
                                    teamId={teamId}
                                    onClick={initialAccessLevelTeam}
                                    onClose={setShowAccessLevel}
                                    setShowToastMessage={setShowToastMessage}
                                    setEditTeamState={setTeamAsyncOpState}
                                />
                            </ModalLyt>
                        )}
                    </Box>
                </Grid>

                <Grid item xs={12}>
                    <Box
                        width={'100%'}
                        display={'flex'}
                        justifyContent={'start'}
                        flexWrap={'wrap'}
                        px={2}
                    >
                        {teamD?.map((item: any, i: number) => {
                            return (
                                <Box
                                    key={i}
                                    sx={{
                                        transition: "all 0.3s ease",
                                        "&:hover": {
                                            transform: "scale(1.05)",
                                            backgroundColor: "withesmoke",
                                            // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                                            // borderRadius: "12px",
                                        },
                                        // padding: "10px", // Add padding to ensure content isn't cut off during hover
                                    }}
                                >
                                    <TeamCart
                                        key={i}
                                        setTeamId={setTeamId}
                                        item={item}
                                        setShowEditForm={setShowEditTeam}
                                        setShowEditAccessForm={setShowAccessLevel}
                                        setShowToastMessage={setShowToastMessage}
                                        setDeleteTeamState={setTeamAsyncOpState}
                                    />
                                </Box>
                            );
                        })}
                    </Box>
                </Grid>

                {showToastMessage && (
                    <DYToastMessage
                        isSuccess={teamAsynOpcState?.isSuccess}
                        message={teamAsynOpcState?.metaData.message}
                        setShow={setShowToastMessage}
                        show={showToastMessage}
                    />
                )}

                <Grid item xs={12}>
                    <Box width={'100%'} height={'15px'}></Box>
                </Grid>
            </Grid>
        </>
    );
};

export default Teams;
